import type { PanelPosition } from "~/components/map";

export type DetailLevel = "minimal" | "compact" | "full";

const MAPPING: Record<PanelPosition, DetailLevel> = {
  hidden: "minimal",
  collapsed: "minimal",
  preview: "compact",
  expanded: "full",
};

export function toDetailLevel(position: PanelPosition): DetailLevel {
  return MAPPING[position];
}
